import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { ClientService } from "@core/services/client.service";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { ClientSimplifiedListDTO } from "@shared/models/client-details-dto";
import { Observable, of } from "rxjs";
import { debounceTime, map, startWith, switchMap, tap } from "rxjs/operators";
import { SearchFormSimplifiedListDTO } from "src/app/modules/private/modules/client/models/search-form-dto";
import { ClientDTO } from "../../models/client-dto";

@Component({
  selector: "app-smartfleet-client-auto-complete",
  templateUrl: "./client-auto-complete.component.html",
  styleUrls: ["./client-auto-complete.component.scss"],
  standalone: false
})
export class ClientAutoCompleteComponent
  implements OnInit, AfterViewInit, OnChanges
{
  loading = false;
  client = new UntypedFormControl();
  searchForm = this.fb.group({
    client: this.client
  });
  wasChangedByUser = false;

  clients$: Observable<ClientSimplifiedListDTO[] | ClientSimplifiedListDTO>;

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() style: string;
  @Input() removeClients: Array<ClientDTO>;
  @Input() onlyParents: boolean;
  @Input() required: boolean;
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Output() onChange: any = new EventEmitter<ClientSimplifiedListDTO>();
  @Input() isNegotiation = false;
  @Input() negotiationId: number;

  constructor(
    private clientService: ClientService,
    private fb: UntypedFormBuilder,
    private loadingDrivebService: LoadingDrivebService
  ) {}

  ngOnInit() {
    this.searchForm.valueChanges.subscribe((r) => {
      this.wasChangedByUser = this.searchForm.get("client").dirty;
    });

    this.clients$ = this.client.valueChanges.pipe(
      startWith(""),
      debounceTime(200),
      tap(
        () => (
          (this.loading = true), this.loadingDrivebService.setAutoMode(false)
        )
      ),
      switchMap((value: string) => {
        if (value) {
          const searchForm = {} as SearchFormSimplifiedListDTO;
          searchForm.tradingName = value.toUpperCase();

          if (this.isNegotiation && this.negotiationId) {
            return this.clientService.listAllWithFiltersNegotiation(
              searchForm,
              this.negotiationId
            );
          }

          return this.clientService.listAllWithFilters(searchForm);
        } else {
          this.onChange.emit({} as ClientSimplifiedListDTO);
          return of([]) as Observable<ClientSimplifiedListDTO[]>;
        }
      }),
      map((result) => {
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
        if (this.removeClients) {
          return result.filter(
            (client) => !this.removeClients.find(({ id }) => client.id === id)
          );
        }

        return result;
      })
    );
  }

  ngAfterViewInit(): void {
    //verifica a pagina em que o autocomplete esta inserido
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "service-request":
          key = "srq-client";
          break;
        case "scheduling-request":
          key = "sr-client";
          break;
        case "service-request-pending":
          key = "srp-client";
          break;
        case "block":
          key = "bl-client";
          break;
        case "driver":
          key = "dr-client";
          break;
        case "vehicle":
          key = "vc-client";
          break;
        case "my-fleet":
          key = "my-fleet-client";
          break;
        case "dashboard":
          key = "ds-client";
          break;
        case "debit-notes":
          key = "dn-client";
          break;
        case "fleet-admin":
          key = "fa-client";
          break;
        case "invoices-validation-list":
          key = "ivl-client";
          break;
        case "erp":
          key = "erp-client";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const client = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.client.setValue(client["tradingName"]);
      }
    } else {
      this.clean();
    }
  }

  ngOnChanges(): void {
    if (this.required && !this.disabled) {
      this.searchForm.controls.client.setValidators([Validators.required]);
    }
  }

  handleChangeClient(
    event: MatOptionSelectionChange,
    client: ClientSimplifiedListDTO
  ) {
    if (event.isUserInput === true) {
      this.onChange.emit(client);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.wasChangedByUser = true;
  }

  setNameFromLocalStorage(localStorageKey: string): void {
    if (
      localStorage.getItem(localStorageKey) != null &&
      localStorage.getItem(localStorageKey) != ""
    ) {
      const client = JSON.parse(localStorage.getItem(localStorageKey));
      this.searchForm.controls.client.setValue(client["tradingName"]);
    }
  }
}
